<template>
  <div>
    <v-dialog
      v-model="core.notsaveDialog"
      :persistent="true"
      max-width="90%"
      width="400"
      :style="`z-index: ${this.core.confirmationIndex};position: fixed;`"
    >
      <v-card>
        <v-toolbar dark color="primary">
          {{ $t("common.noAutoSave_titledisclaimer") }}
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-card-text
          style="text-align: justify"
          v-html="$t('common.noAutoSave_disclaimerContent')"
        ></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="core.notsaveDialog = false">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              core.updateEnableSaveToLocalStorage(
                !core.enableSaveToLocalStorage
              )
            "
          >
            {{ $t("common.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="core.saveDialog"
      :persistent="true"
      max-width="90%"
      width="400"
      :style="`z-index: ${this.core.confirmationIndex};position: fixed;`"
    >
      <v-card>
        <v-toolbar dark color="primary">
          {{ $t("common.autoSave_titledisclaimer") }}
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-card-text style="text-align: justify">{{
          $t("common.autoSave_disclaimerContent")
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="core.saveDialog = false">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              core.updateEnableSaveToLocalStorage(
                !core.enableSaveToLocalStorage
              )
            "
          >
            {{ $t("common.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["core"],
};
</script>